import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import type { TableLoadingViewProps } from '../types';

export function TableLoadingView({ columnCount }: TableLoadingViewProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell
          colSpan={columnCount}
          className="px-4 py-6 text-center text-muted-foreground"
        >
          Loading…
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
